import type { PartLike } from "./types";

/** Plan-hidden parts (lid copy, duplicate connector instance, …) on root or nested `properties`. */
export function isPartHiddenFromPlan(part: PartLike): boolean {
  if (part.dontShowInPlan === true) return true;
  return part.properties?.dontShowInPlan === true;
}

/**
 * Part types that are built but are no article: the Ausschnitt is a hole in a
 * panel, Volume and Measurements are helpers of the 3D view. They have no
 * price and no row in the Stückliste.
 */
const ARTICLE_FREE_PART_TYPES: ReadonlySet<string> = new Set([
  "Cutout",
  "Measurements",
  "Volume",
]);

/** Whether the part is no article (see `ARTICLE_FREE_PART_TYPES`), on root or nested `properties`. */
export function isArticleFreePart(part: PartLike): boolean {
  return ARTICLE_FREE_PART_TYPES.has((part.properties ?? part).type);
}
